export default "__VITE_ASSET__38f493e9__"